import { render, staticRenderFns } from "./help.vue?vue&type=template&id=2fc9200d&scoped=true&"
import script from "./help.vue?vue&type=script&lang=ts&"
export * from "./help.vue?vue&type=script&lang=ts&"
import style0 from "./help.vue?vue&type=style&index=0&id=2fc9200d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc9200d",
  null
  
)

export default component.exports